import styled, { createGlobalStyle } from 'styled-components/macro'
import { Container } from 'components/container'
import { mq } from 'styles/mq'

export const GlobalSnap = createGlobalStyle`
  body {
    scroll-snap-type: y proximity;
  }
`

export const PageContent = styled(Container)`
  ${mq.ltLarge} {
    &,
    > div {
      display: contents;
    }
  }

  ${mq.large} {
    display: grid;
    grid-template-columns: 48rem 1fr;
  }
`

export const Main = styled.main`
  ${mq.large} {
    max-width: 72rem;
  }
`

export const Nav = styled.nav`
  ${mq.large} {
    padding-right: 3rem;
    margin-right: 9rem;
    border-right: 1px solid #626262;
  }
`

export const BottomSpacing = styled.div`
  ${mq.ltLarge} {
    height: 5rem;
  }
`
